'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.heroSliderComponent = undefined;

var _marked = require('marked');

var _marked2 = _interopRequireDefault(_marked);

var _markedRenderer = require('./../../../common/core/markedRenderer');

var _markedRenderer2 = _interopRequireDefault(_markedRenderer);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_marked2.default.setOptions({
    renderer: _markedRenderer2.default,
    breaks: true,
    sanitize: true
});

var heroSliderComponent = exports.heroSliderComponent = {
    template: require('./hero-slider.html'),
    bindings: {
        banners: '<',
        settings: '<'
    },
    controllerAs: 'vm',
    controller: ["Enums", function heroSliderController(Enums) {
        'ngInject';

        var vm = this;
        vm.$onChanges = bindingChanges;

        vm.bannerTextAlignmentClasses = Enums.bannerTextAlignmentClasses;

        function bindingChanges(changes) {
            if (changes.banners) {
                changes.banners.currentValue.forEach(function (banner, index) {
                    vm.banners[index].content = banner.content ? (0, _marked2.default)(changes.banners.currentValue[index].content || '') : null;
                    vm.banners[index].title = banner.title ? (0, _marked2.default)(changes.banners.currentValue[index].title || '') : null;
                });
            }
        }
    }]
};


//////////////////
// WEBPACK FOOTER
// ./features/seller/components/hero-slider.js
// module id = 1010
// module chunks = 0